
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/audyt-elektroniki-i-firmware",
      function () {
        return require("private-next-pages/audyt-elektroniki-i-firmware.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/audyt-elektroniki-i-firmware"])
      });
    }
  